import { Link, useNavigate, useLocation } from "react-router-dom";
import { CONTACT } from "@/lib/content";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const jump = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 350);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="site-footer" style={{ background: "var(--ink)" }} className="pt-[70px] pb-9">
      <div className="wrap">
        <div className="grid gap-10 pb-14 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="font-serif text-[22px] tracking-[0.12em]">LUXEBOND</div>
            <p className="mt-4 max-w-[280px] text-[14px] leading-relaxed" style={{ color: "var(--stone)" }}>
              Epoxy flooring and surfacing for homes, countertops, and industrial facilities.
              Poured with precision, finished with restraint.
            </p>
          </div>

          <div>
            <h5 className="font-mono-lbl text-[11px] mb-4" style={{ color: "var(--stone-dim)" }}>Services</h5>
            <ul className="flex flex-col gap-3 text-[13.5px]" style={{ color: "var(--stone)" }}>
              <li><button onClick={() => jump("services")} className="hover:text-[var(--brass-bright)] transition-colors">Garage Floors</button></li>
              <li><button onClick={() => jump("services")} className="hover:text-[var(--brass-bright)] transition-colors">Home Floors</button></li>
              <li><button onClick={() => jump("services")} className="hover:text-[var(--brass-bright)] transition-colors">Countertops</button></li>
              <li><button onClick={() => jump("services")} className="hover:text-[var(--brass-bright)] transition-colors">Industrial</button></li>
            </ul>
          </div>

          <div>
            <h5 className="font-mono-lbl text-[11px] mb-4" style={{ color: "var(--stone-dim)" }}>Studio</h5>
            <ul className="flex flex-col gap-3 text-[13.5px]" style={{ color: "var(--stone)" }}>
              <li><Link to="/finishes" className="hover:text-[var(--brass-bright)] transition-colors">Finish Library</Link></li>
              <li><Link to="/process" className="hover:text-[var(--brass-bright)] transition-colors">Our Process</Link></li>
              <li><Link to="/gallery" className="hover:text-[var(--brass-bright)] transition-colors">Gallery</Link></li>
              <li>
                <a href={CONTACT.visualizer} target="_blank" rel="noopener noreferrer"
                   className="hover:text-[var(--brass-bright)] transition-colors">Floor Visualizer ↗</a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-mono-lbl text-[11px] mb-4" style={{ color: "var(--stone-dim)" }}>Contact</h5>
            <ul className="flex flex-col gap-3 text-[13.5px]" style={{ color: "var(--stone)" }}>
              <li><button onClick={() => jump("quote")} className="hover:text-[var(--brass-bright)] transition-colors">Free Quote</button></li>
              <li><a href={CONTACT.phoneHref} className="hover:text-[var(--brass-bright)] transition-colors">{CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-[var(--brass-bright)] transition-colors break-all">{CONTACT.email}</a></li>
              <li><Link to="/admin" className="hover:text-[var(--brass-bright)] transition-colors" style={{ color: "var(--stone-dim)" }}>Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="hairline" />
        <div className="flex flex-wrap items-center justify-between gap-3 pt-6">
          <span className="text-[12px]" style={{ color: "var(--stone-dim)" }}>
            © 2026 LuxeBond Epoxy Services. All rights reserved.
          </span>
          <span className="text-[12px]" style={{ color: "var(--stone-dim)" }}>
            Licensed &amp; insured · Free estimates · 10-year warranty
          </span>
        </div>
      </div>
    </footer>
  );
}
